import type { ReactNode } from "react";

interface KBDProps {
  children: ReactNode;
  className?: string;
}

/**
 * Styled keyboard shortcut badge.
 */
export function KBD({ children, className = "" }: KBDProps) {
  return (
    <kbd
      className={`inline-flex items-center justify-center min-w-[1.5rem] h-5 px-1.5 rounded border border-border bg-bg-surface text-[11px] font-mono font-medium text-text-muted shadow-sm ${className}`}
    >
      {children}
    </kbd>
  );
}
